import {Injectable} from '@angular/core';
import {RequestOptionsArgs, Response, Request, Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import {AppRequestOptionArgs} from './AppRequestOptionArgs';

/**
 * Wraps Angular's http client in order to handle 500 server errors gracefully.
 */
@Injectable()
export class HttpClient {
  /**
   * A boolean to make sure the message
   * is not shown multiple times for subsequent requests
   * @type {boolean}
   */
  protected messageShown = false;

  /**
   * A boolean to know if the messageShown variable is scheduled
   * to change back to false
   * @type {boolean}
   */
  protected messageShownScheduledToReset = false;


  constructor(private http: Http) {}

  /**
   *Performs a request with `request` http method. Add 500 error handler method.
   */
  public request(url: string | Request, options?: AppRequestOptionArgs): Observable<Response> {
    this.resetMessageShown();
    return this.http.request(url, options).catch((error) => this.handle500(error, options));
  }

  /**
   * Performs a request with `get` http method. Add 500 error handler method.
   */
  public get(url: string, options?: AppRequestOptionArgs): Observable<Response> {
    this.resetMessageShown();
    return this.http.get(url, options).catch((error) => this.handle500(error, options));
  }
  /**
   * Performs a request with `post` http method.
   */
  public post(url: string, body: any, options?: AppRequestOptionArgs): Observable<Response> {
    this.resetMessageShown();
    return this.http.post(url, body, options).catch((error) => this.handle500(error, options));
  }
  /**
   * Performs a request with `put` http method.
   */
  public put(url: string, body: any, options?: AppRequestOptionArgs): Observable<Response> {
    this.resetMessageShown();
    return this.http.put(url, body, options).catch((error) => this.handle500(error, options));
  }
  /**
   * Performs a request with `delete` http method
   * @param url
   * @param options
   * @returns {Observable<Response>}
   */
  public delete(url: string, options?: AppRequestOptionArgs): Observable<Response> {
    return this.http.delete(url, options).catch((error) => this.handle500(error, options));
  }
  /**
   * Performs a request with `patch` http method.
   */
  public patch(url: string, options?: AppRequestOptionArgs): Observable<Response> {
    this.resetMessageShown();
    return this.http.patch(url, options).catch((error) => this.handle500(error, options));
  }
  /**
   * Performs a request with `head` http method.
   */
  public head(url: string, options?: AppRequestOptionArgs): Observable<Response> {
    this.resetMessageShown();
    return this.http.head(url, options).catch((error) => this.handle500(error, options));
  }
  /**
   * Performs a request with `options` http method.
   */
  public options(url: string, options?: AppRequestOptionArgs): Observable<Response> {
    this.resetMessageShown();
    return this.http.options(url, options).catch((error) => this.handle500(error, options));
  }

  /**
   * Reset
   */
  private resetMessageShown() {
    if (this.messageShownScheduledToReset)
      return;
    this.messageShownScheduledToReset = true;
    setTimeout(() => {
      this.messageShownScheduledToReset = false;
      this.messageShown = false
      }, 2000);
  }

  /**
   * Check if the is 500 error and present alert.and the if return Observable of.
   * @param {Response} error
   * @return {Observable<any>}
   */
  private handle500(error: Response, options: AppRequestOptionArgs): Observable<any> {
    if (!options.throwError) {
      if (error.status === 500) {
        this.presentErrorAlert();
        return Observable.empty();
      } else if (error.status === 0) {
        this.presentNetworkAlert();
        return Observable.empty();
      }
    }

    return <Observable<any>>Observable.throw(error);
  }

  /**
   * Presents the alert for 500 error.
   */
  private presentErrorAlert() {
    if (this.messageShown)
      return;
    // TODO: implement some sort of modal error notification
    window.alert('There seems to be a server error.');
    this.messageShown = true;
  }

  /**
   * Present an alert for a network connection
   */
  private presentNetworkAlert() {
    if (this.messageShown)
      return;
    // TODO: implement some sort of modal error notification
    window.alert('There seems to be no network connection. Please check your network connection and try again.');
    this.messageShown = true;
  }

  /**
   * Converts an error response to an object.
   * @param {Response} res The error response from the server
   * @returns {Object} The Object version of the response
   */
  private convertResponseToObject(res: Response) {
    return  {
      status: res.status,
      statusText: res.statusText,
      bytesLoaded: res.bytesLoaded,
      totalBytes: res.totalBytes,
      headers: res.headers,
      url: res.url,
      type: res.type,
      body: res.text()
    };
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/http-client/http-client.service.ts